import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import * as currentPageActions from '../redux/actions/current-page'
import LoginForm from '../components/login/login-form'

import './page-styles.css'
import client from "../axios";

const Login = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(currentPageActions.dashboard())
  }, [])

  useEffect(() => {
    client.delete('/api/auth/logout')
  }, [])

  return (
    <div className="container-fluid p-0 vh-100 position-relative overflow-hidden">

      {/* 1. 전체 화면 배경 사진 (가장 밑에 깔리는 레이어) */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(/img/background.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center bottom',
          backgroundRepeat: 'no-repeat',
          zIndex: 0
        }}
      />

      {/* 2. 왼쪽 브랜딩 문구 영역 (사진 위에 흰색 텍스트로 올라감) */}
      <div
        className="position-absolute top-0 bottom-0 start-0 d-none d-md-flex flex-column justify-content-center text-white"
        style={{
          zIndex: 1,
          width: 'calc(100% - 450px)', // 오른쪽 로그인 패널 너비를 뺀 나머지 영역 사용
          paddingLeft: '6%', // 왼쪽 여백
          paddingBottom: '17%', // 상단 여백
        }}
      >
        <div style={{ transform: 'translateY(-10%)' }}> {/* 세로 중앙에서 살짝 위로 올리기 위함 */}
          <h1 className="fw-bold mb-4" style={{ fontSize: '2.5rem' }}>SubulEasy</h1>
          <h4 className="fw-bold mb-3" style={{ lineHeight: '1.5' }}>
            식품제조업의 지속가능한 성장을 위해<br />
            기본에 충실한 디지털 혁신을 완성한다
          </h4>
          <p style={{ fontSize: '1.1rem', opacity: 0.9, lineHeight: '1.6' }}>
            새롭고 심플한 업무 방식의 변화는 효율적인 시간활용으로<br />
            시간비용은 감소시키고 업무 효율성과 생산성은 증가되도록 도와줍니다.
          </p>
        </div>

        {/* 하단 좌측 저작권 영역 */}
        <div className="position-absolute" style={{ bottom: '40px', left: '8%' }}>
          <p style={{ fontSize: '0.85rem', opacity: 0.7, margin: 0 }}>
            Copyright 2025. GRAPE. All rights reserved
          </p>
        </div>
      </div>

      {/* 3. 오른쪽 위아래로 꽉 차는 반투명 폼 패널 (사진 위에 덮어씌워짐) */}
      <div
        className="position-absolute top-0 bottom-0 end-0 d-flex flex-column justify-content-center shadow-lg"
        style={{
          width: '450px',
          backgroundColor: 'rgba(255, 255, 255, 0.85)', // 투명도를 사진과 비슷하게 살짝 올렸습니다. (원하시면 0.6으로 유지)
          zIndex: 2,
          padding: '4rem 3rem'
        }}
      >
        {/* 로그인 폼 컴포넌트만 단독으로 들어갑니다 */}
        <div className="w-100">
          <LoginForm />
        </div>
      </div>

    </div>
  )
}

export default Login